let config = {
  baseURL: getBaseUrl(),
};

function getBaseUrl() {
  if (window.location.href.indexOf("localhost") >= 0 || process.env.NODE_ENV === "development") {
    return "/api/";
  } else {
    return process.env.VUE_APP_API_URL;
  }
}
export default config;
